import { ISwrConfiguration, useFetch } from 'lib/hooks/useFetch';
import { IUserPopulationAttributes } from 'lib/types/user';
import _ from 'lodash';
import { IAdminCourse } from './types';

export const useCourses = (options?: ISwrConfiguration) =>
  useFetch<IAdminCourse[]>('/admin/courses', options);

export const useCourse = (id: number, options?: ISwrConfiguration) => {
  const shouldFetch = !!id && (options?.shouldFetch ?? true);
  const res = useCourses({ ...options, shouldFetch });
  return { ...res, data: _.find(res.data, { id }) as IAdminCourse };
};

export const useEnrolledCourses = (options?: ISwrConfiguration) => {
  const res = useCourses(options);
  return {
    ...res,
    data: _.filter(res.data, (x) => x.isEnrolled),
  };
};

export const useAssignableCourses = (options?: ISwrConfiguration) => {
  const res = useCourses(options);
  return {
    ...res,
    data: _.filter(
      res.data,
      (x) =>
        x.isEnrolled && !x.isDeleted && x.hasModulesAvailableInContentLibrary
    ),
  };
};

interface IPopulationAttributesOptions {
  includeEmptyValues?: boolean;
}

export const usePopulationAttributes = (
  populationAttributesOptions: IPopulationAttributesOptions,
  swrOptions?: ISwrConfiguration
) =>
  useFetch<IUserPopulationAttributes>(
    ['/admin/dashboard/population-attributes', populationAttributesOptions],
    swrOptions
  );
